export const CAMERA_CHANGE = "CAMERA_CHANGE"
export const CAMERA_FRAME_UPDATE = "CAMERA_FRAME_UPDATE"
export const PLAY_PAUSE = "PLAY_PAUSE"
export const FRAME = "FRAME"
export const CANVAS_RESIZE = "CANVAS_RESIZE"
export const KEY_CONTROL = "KEY_CONTROL"
